const getMmsAltText = (mmsText, brandName) => {
	const triggerWords = [
		'introducing',
		'new',
		'our',
		'best-selling',
		'best sellers',
		'best seller',
		'bestselling',
		'your',
	];
	let result = '';

	// Convert mmsText to lowercase for case-insensitive comparison
	const lowerMainString = mmsText?.toLowerCase();

	for (const word of triggerWords) {
		const lowerWord = word.toLowerCase();
		const index = lowerMainString?.indexOf(lowerWord);
		if (index !== -1) {
			// Find the starting index of the next 6 words
			const startIndex = mmsText?.indexOf(' ', index);
			let count = 0;
			let endIndex = startIndex;
			while (count < 6 && endIndex !== -1) {
				endIndex = mmsText?.indexOf(' ', endIndex + 1);
				count++;
			}

			if (startIndex !== -1 && endIndex !== -1) {
				const nextWords = mmsText?.substring(startIndex + 1, endIndex);
				result = nextWords;
				break;
			}
		}
	}

	// If none of the trigger words are found, return the first 6 words
	if (!result) {
		const words = mmsText?.split(' ').slice(0, 6);
		result = words?.join(' ');
	}

	return `${result} from ${brandName}`;
};

export default getMmsAltText;
